import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {PriceLevelScheduleSearchModel} from "../price-level-schedule-search.model";
import {PriceLevelScheduleEntityModel} from "../price-level-schedule-entity.model";
import {EditParams} from "../../../framework/entity/edit/edit-page/edit-params";

@Component({
    selector: "wbo-price-level-schedule-search-page",
    templateUrl: "./price-level-schedule-search-page.component.html",
    providers: [provideSearchModel(PriceLevelScheduleSearchModel), provideEntityModel(PriceLevelScheduleEntityModel)]
})
export class PriceLevelScheduleSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }

    getPriceLevelEditParams(dataItem: any): EditParams {
        return new EditParams(dataItem["priceLevelId"]);
    }
}
